<template>
  <div class="container join-wrapper" ref="myquestionnaire">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="questionnaireData.length > 0 ? '已加载完成' : ''"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="my_join" v-for="questionnaire in questionnaireData" :key="questionnaire.id">
        <div class="join_info" style="padding: 0 15px 0" @click="$router.push({path: '/myQuestionnaire/view', query: {id: questionnaire.id}})">
          <div class="title_time">
            <p class="van-multi-ellipsis--l2">{{questionnaire.questionnairetitle}}</p>
            <span>{{questionnaire.createdate}} {{questionnaire.createtime}}</span>
          </div>
        </div>
        <!-- <van-icon name="arrow" /> -->
      </div>
    </van-list>
    <div class="noData" v-if="finished && questionnaireData.length === 0">
      <img src="../../../assets/images/noData.png" alt="">
      <p>抱歉，暂无相关问卷</p>
    </div>
  </div>
</template>

<script>
  import API from '../../../interface/api'
  const pageload = 10
  export default {
    name: 'myQuestionnaire',
    data () {
      return {
        loading: false,
        finished: false,
        error: false,
        index: 1,
        questionnaireData: [],
        scroll: 0
      }
    },
    created () {
      this.$toast.allowMultiple()
    },
    activated () {
      if (this.scroll) {
        this.$refs.myquestionnaire.scrollTop = this.scroll
      }
    },
    methods: {
      onLoad () {
        this.$fetch.get(API.MEMBERWJLIST, {
          pageNum: this.index,
          pageSize: pageload
        }).then(response => {
          // console.log(response)
          if (response.data.wjResultList.length > 0) {
            this.questionnaireData = this.questionnaireData.concat(response.data.wjResultList)
            this.index += 1
            this.loading = false
            if (response.data.wjResultList.length < pageload) {
              this.finished = true
            }
          } else {
            this.loading = false
            this.finished = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.finished = true
          this.error = true
        })
      }
    },
    beforeRouteLeave (to, from, next) {
      if (to.path === '/myQuestionnaire/view') {
        this.scroll = this.$refs.myquestionnaire.scrollTop
      }
      next()
    }
  }
</script>

<style lang="stylus">
</style>